import { env } from '@/config/env'

const MOBILE_IMPERSONATION_PORT = '8080'

function getApiBaseUrl(): string {
  return env.apiBaseUrl || window.location.origin
}

export function getMobileImpersonationUrl(accessToken: string): string {
  const apiUrl = new URL(getApiBaseUrl(), window.location.origin)
  const host = apiUrl.hostname.replace(/^api\./, '')

  return `${apiUrl.protocol}//${host}:${MOBILE_IMPERSONATION_PORT}?access_token=${encodeURIComponent(accessToken)}`
}
